import { Component, Input } from '@angular/core';
import { NavigationDataService } from '../../../../shared/services/navigation-data.service';

@Component({
  selector: 'app-collection-card',
  templateUrl: './collection-card.component.html',
  styleUrls: ['./collection-card.component.scss'],
})
export class CollectionCardComponent {
  @Input() card: any;
  @Input() isMapView = false;
  @Input() isAccommodationCampaign = false;

  constructor(private readonly navigationDataService: NavigationDataService) {}

  getBadgeUrl(cardName: string): string {
    switch (cardName) {
      case 'MBH SZÉP-kártya':
        return '/assets/images/szep-card-campaign/mbh_szep_card.png';
      case 'K&H SZÉP-kártya':
        return '/assets/images/szep-card-campaign/kh_szep_card.png';
      case 'OTP SZÉP-kártya':
        return '/assets/images/szep-card-campaign/otp_szep_card.png';
      default:
        return '';
    }
  }

  accommodationClassText(text: string): string {
    return text?.trim().endsWith('𝐒') ? text + 'uperior' : text;
  }

  navigateToAccommodation(): void {
    if (this.card) {
      this.navigationDataService.setData(this.card);
    }
  }
}
